"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const Select_1 = __importDefault(require("@Components/Selectors/Select"));
const FieldErrorSection_1 = require("@Components/Fields/FieldErrorSection");
const clsx_1 = __importDefault(require("clsx"));
class Dropdown extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "onChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => {
                let value;
                if (this.props.isNumberType) {
                    value = data && data.id ? Number(data.id) : 0;
                }
                else {
                    value = data && data.label ? data.label : '';
                }
                this.props.onChange && this.props.id && this.props.onChange(value || '', this.props.id || '');
            }
        });
    }
    render() {
        const { mainColor = true, options, isDisabled, selectedValue, defaultValue, placeholder, label, assistiveText, className, isPhoneCodeType, isBorder, small, errorMessage, isClearable, isSearchable, required, onSelect = () => { }, onChange, tooltip, } = this.props;
        const classNames = (0, clsx_1.default)('dropdown-component', mainColor ? 'main-color-set' : 'second-color-set', isPhoneCodeType && 'phone-code-type', isBorder && 'border', small && 'small', errorMessage && 'error', className);
        return (react_1.default.createElement("div", { className: classNames, "data-testid": "dropdown-component" },
            selectedValue && label && react_1.default.createElement("label", { className: "label" }, label),
            react_1.default.createElement(Select_1.default, { onValueChange: onChange ? this.onChange : onSelect, options: options, isDisabled: isDisabled, selectedValue: selectedValue, placeholder: placeholder ? placeholder : label, defaultValue: defaultValue, isClearable: isClearable, isSearchable: isSearchable }),
            (0, react_1.isValidElement)(tooltip) && tooltip,
            react_1.default.createElement(FieldErrorSection_1.FieldErrorSection, { errorMessage: errorMessage, assistiveText: assistiveText, required: required })));
    }
}
exports.default = Dropdown;
